import React from 'react';
import Cardkitchen from '../components/Cardkitchen';

const Kitchen = () => {
  return (
    <section>
      <div>
        <Cardkitchen />
      </div>
    </section>
  );
};

export default Kitchen;
